import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useNavigate } from 'react-router-dom';
import GroupList from './GroupList';

const GroupBase = () => {
  const navigate = useNavigate();

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className=" flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Group Policy" dropdown={2} />

        <Card className="flex-1 h-full" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <GroupList />
        </Card>
      </div>
    </div>
  );
};

export default GroupBase;
